<template>
  <div class="page overview hide__3d--mobile">
    <World :name="'world-intro'" :key="'world-intro'" v-if="windowWidth > 992"></World>

    <div class="box__extra position-absolute d-none d-lg-flex align-items-center" v-if="sliderIndex == 2">
      <div class="box__extra--inner">
        <h4 class="font-black text-uppercase mb-3" v-html="$t('SECTION01_TIP01')">Tip</h4>
        <p class="mt-6 text-center" v-html="$t('SECTION01_TIP02')">„Before you can discover another district, you
          need to have made sure that you have visited
          all the iconic buildings and learnt about the
          iconic products .<br>
          If you want to take part in the challenge, you
          will need to do the quiz in each district.“
        </p>
      </div>
    </div>

   <!-- <div class="box__extra position-absolute d-none d-lg-flex align-items-center justify-content-center" v-if="sliderIndex == 3 && user.gift_active != 0">-->
    <div class="box__extra position-absolute d-none d-lg-flex align-items-center justify-content-center" v-if="sliderIndex == 3 && user.gift_active != 0 && !(user.user.language == 'NL' && user.user.is_douglas == 1)">
      <div class="box__extra--inner text-center d-flex align-items-center justify-content-center flex-column">
        <h4 class="font-black text-uppercase mb-3" v-html="$t('SECTION01_PRIZE01')">Your prize</h4>
        <img src="@/assets/gifts/gift_ru.jpg" class="img-fluid" v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
        <img src="@/assets/gifts/gift_uk.jpg" class="img-fluid" v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country !='ME' && user.user.is_limited_to_lounge != 1">
        <img src="@/assets/gifts/gift_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
        <img src="@/assets/gifts/gift_it.jpg" class="img-fluid" v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
        <img src="@/assets/gifts/gift_bx.jpg" class="img-fluid" v-if="user.user.country == 'BX'">
        <img src="@/assets/gifts/gift_me.jpg" class="img-fluid" v-if="user.user.country == 'ME'">
        <img src="@/assets/gifts/gift_tr.jpg" class="img-fluid" v-if="user.user.country == 'TX'">


        <img src="@/assets/gifts/gift_jbl_tt_ch.jpg" class="img-fluid" v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
        <img src="@/assets/gifts/gift_jbl_tt_cx.jpg" class="img-fluid" v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">
        <img src="@/assets/gifts/gift_jbl_tt_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
        <img src="@/assets/gifts/gift_jbl_tt_fr.jpg" class="img-fluid" v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
        <img src="@/assets/gifts/gift_jbl_tt_it.jpg" class="img-fluid" v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
        <img src="@/assets/gifts/gift_jbl_tt_pt.jpg" class="img-fluid" v-if="user.user.language == 'PT' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
        <img src="@/assets/gifts/gift_jbl_tt_de_1.jpg" class="img-fluid" v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">



        <div v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
          <p class="mt-0 text-center font-size-18">Ночная крем-маска</p>
        </div>
        <div v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country != 'ME' && user.user.is_limited_to_lounge != 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
          <p class="mt-0 text-center font-size-18">Wrinkle Smoothing Cream</p>
        </div>
        <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Essential Energy</p>
          <p class="mt-0 text-center font-size-18">Moisturizing Gel Cream</p>
        </div>
        <div v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune<br>Eye</p>
          <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
        </div>
        <div v-if="user.user.language == 'BX'">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
          <p class="mt-0 text-center font-size-18">Uplifting and Firming<br>Day Cream</p>
        </div>
        <div v-if="user.user.country == 'ME'">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
          <p class="mt-0 text-center font-size-18">Defense Refresh Mist</p>
        </div>
        <div v-if="user.user.country == 'TX'">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
          <p class="mt-0 text-center font-size-18">Overnight Wrinkle <br> Resisting Cream</p>
        </div>


        <div v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
          <p class="mt-0 text-center font-size-18">50ml</p>
        </div>
        <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FSLX</p>
          <p class="mt-0 text-center font-size-18">Concentrated<br> Balancing Softener</p>
        </div>
        <div v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
          <p class="mt-0 text-center font-size-18">Crème Lift Fermeté<br>Jour et Nuit 50 ml</p>
        </div>
        <div v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune <br>Eye</p>
          <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
        </div>
        <div v-if="user.user.language == 'PT' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
          <p class="mt-0 text-center font-size-18">Brightening Gel Cream</p>
        </div>
        <div v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FUTURE SOLUTION LX</p>
          <p class="mt-0 text-center font-size-12 small" v-html="$t('GIFT_DE_INFO')"></p>
        </div>
        <div v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">

          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'EN'">We will let you know very soon!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'ES'">¡Se lo haremos saber muy pronto!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'FR'">Nous vous le ferons savoir très bientôt !</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PL'">Damy ci znać wkrótce!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'DE'">Das werden Sie hier sehr bald erfahren!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'IT'">Vi faremo sapere molto presto!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'RU'">Мы сообщим вам очень скоро!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'NL'">We laten het u binnenkort weten!</p>
          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PT'">Informá-lo-emos muito em breve!</p>



        </div>
      </div>
    </div>

    <div class="skip--intro position-absolute d-flex align-items-end flex-column">
      <p class="mb-0 color--red small" v-html="$t('SECTION01_SKIP01')">Already been there?</p>
      <p class="text-uppercase font-black color--red icon--skip" v-on:click="startWorld()" v-html="$t('SECTION01_SKIP02')">Skip</p>
    </div>

    <div class="container-fluid position-relative">

      <div class="row">
        <div class="col-10 offset-1 offset-xl-1 col-lg-6 d-flex justify-content-center">

          <Slick ref="slick" :options="slickOptions" @afterChange="handleAfterChange" class="intro__slider w-100">

            <div class="slide slide-01">
              <div class="slide__inner">
                <h3 class="slide--headline text-center text-lg-left" v-html="$t('SECTION01_TEXT01')">Welcome to the Shiseido J-Beauty Tokyo Tour</h3>

                <div class="row">
                  <div class="col-4 offset-4 col-lg-3 offset-lg-0 mb-5">
                    <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide">
                  </div>
                  <div class="col-12 col-lg-7 offset-lg-1 d-flex align-items-center flex-column d-lg-block">
                    <h4 class="slide--subheadline text-center text-lg-left" v-html="$t('SECTION01_TEXT02')">Konnichiwa</h4>
                    <p class="slide--text text-center text-lg-left" v-html="$t('SECTION01_TEXT03')">
                      „My name is Miyuki Dori and I will be your tour guide today :-)“
                    </p>
                    <img src="@/assets/global/world_1_mobile.png" class="img-fluid my-4 d-block d-lg-none">
                    <div class="btn btn-red text-uppercase" v-on:click="sliderNext()" v-html="$t('SECTION01_TEXT04')">
                      Hello Miyuki :)
                    </div>
                    <p class="small mt-1 color--red" v-html="$t('SECTION01_TEXT05')">(click here to talk with Miyuki)</p>
                  </div>
                </div>

              </div>
            </div>

            <div class="slide slide-02">
              <div class="slide__inner">

                <h3 class="slide--headline text-center text-lg-left" v-html="$t('SECTION01_TEXT06')">Ginza, Ueno Park<br>and Asakusa</h3>

                <div class="row">
                  <div class="col-6 offset-3 col-lg-3 offset-lg-0 mb-5">
                    <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide">
                  </div>
                  <div class="col-12 col-lg-7 offset-lg-1 d-flex align-items-center flex-column d-lg-block">
                    <p class="slide--text text-center text-lg-left" v-html="$t('SECTION01_TEXT07')">
                      „I would love to show you 3 famous districts in Tokyo, and explore the most iconic sights in each district. Whilst discovering the sights you will also discover the Shiseido
                      iconic
                      products.“
                    </p>
                    <img src="@/assets/global/world_1_mobile.png" class="img-fluid my-4 d-block d-lg-none">
                    <div class="btn btn-red text-uppercase" v-on:click="sliderNext()" v-html="$t('SECTION01_TEXT08')">
                      Okay cool :)
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="slide slide-03">
              <div class="slide__inner">

                <h3 class="slide--headline  text-center text-lg-left" v-html="$t('SECTION01_TEXT09')">How to get<br>around Tokyo</h3>

                <div class="row">
                  <div class="col-6 offset-3 col-lg-3 offset-lg-0 mb-5">
                    <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide">
                  </div>
                  <div class="col-12 col-lg-7 offset-lg-1 d-flex align-items-center flex-column d-lg-block">
                    <p class="slide--text text-center text-lg-left" v-html="$t('SECTION01_TEXT10')">
                      „Because Tokyo can be really busy I´ll show you how to navigate through the different districts.
                      If you are visiting on your laptop use your arrow or W/S keys , if you are visiting
                      on your mobile you´ll need to use the circular fields on the left and right
                      side to look around and move“ </p>
                    <div class="box__extra d-flex align-items-center m-3" v-if="windowWidth < 992">
                      <div class="box__extra--inner">
                        <h4 class="font-black text-uppercase mb-3" v-html="$t('SECTION01_TIP01')">Tip</h4>
                        <p class="mt-3 mt-xl-6 text-center" v-html="$t('SECTION01_TIP02')">„Before you can discover another district, you
                          need to have made sure that you have visited
                          all the iconic buildings and learnt about the
                          iconic products .<br>
                          If you want to take part in the challenge, you
                          will need to do the quiz in each district.“
                        </p>
                      </div>
                    </div>
                    <div class="btn btn-red text-uppercase" v-on:click="sliderNext()" v-html="$t('SECTION01_TEXT11')">
                      Thank you Miyuki
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slide slide-04">
              <div class="slide__inner">

                <h3 class="slide--headline text-center text-lg-left" v-html="$t('SECTION01_TEXT12')" v-if="!(user.user.language == 'DE' && user.gift_active == 0)">Visit tokyo and<br>win a prize</h3>
                <h3 class="slide--headline text-center text-lg-left" v-html="$t('SECTION01_TEXT12_NO_GIFT')" v-if="(user.user.language == 'DE' && user.gift_active == 0)"></h3>

                <div class="row">
                  <div class="col-6 offset-3 col-lg-3 offset-lg-0 mb-5">
                    <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide">
                  </div>
                  <div class="col-12 col-lg-7 offset-lg-1 d-flex align-items-center flex-column d-lg-block">
                    <!--<p class="slide&#45;&#45;text text-center text-lg-left" v-if="user.gift_active != 0">-->
                    <p class="slide--text text-center text-lg-left" v-html="$t('SECTION01_TEXT13')" v-if="user.gift_active != 0 && !(user.user.language == 'NL' && user.user.is_douglas == 1)">
                      „After exploring everything in each district, you have the chance to take a quiz and receive a Tokyo Souvenir Pin, collect all 3 Souvenir pins and you can win a prize. You have
                      three attempts at each quiz . To get the Souvenir Pin you must reach 80% in each quiz, when you have all 3 pins you qualify for this gift“
                    </p>
                    <p class="slide--text text-center text-lg-left" v-html="$t('SECTION01_TEXT13_NO_GIFT')" v-if="user.gift_active == 0 || (user.user.language == 'NL' && user.user.is_douglas == 1)">
                      „After exploring everything in each district, you have the chance to take a quiz and receive a Tokyo Souvenir Pin. You have three attempts at each quiz. To get the Souvenir Pin you must reach 80% in each quiz.
                    </p>
                    <!--<div class="box__extra d-flex align-items-center m-3" v-if="windowWidth < 992 && user.gift_active != 0">-->
                    <div class="box__extra d-flex align-items-center m-3" v-if="windowWidth < 992 && user.gift_active != 0 && !(user.user.language == 'NL' && user.user.is_douglas == 1)">
                      <div class="box__extra--inner text-center d-flex justify-content-center align-items-center flex-column">
                        <h4 class="font-black text-uppercase mb-3" v-html="$t('SECTION01_PRIZE01')">Your prize</h4>
                        <img src="@/assets/gifts/gift_ru.jpg" class="img-fluid" v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                        <img src="@/assets/gifts/gift_uk.jpg" class="img-fluid" v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country !='ME' && user.user.is_limited_to_lounge != 1">
                        <img src="@/assets/gifts/gift_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                        <img src="@/assets/gifts/gift_it.jpg" class="img-fluid" v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                        <img src="@/assets/gifts/gift_bx.jpg" class="img-fluid" v-if="user.user.country == 'BX'">
                        <img src="@/assets/gifts/gift_me.jpg" class="img-fluid" v-if="user.user.country == 'ME'">
                        <img src="@/assets/gifts/gift_tr.jpg" class="img-fluid" v-if="user.user.country == 'TX'">

                        <img src="@/assets/gifts/gift_jbl_tt_ch.jpg" class="img-fluid" v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
                        <img src="@/assets/gifts/gift_jbl_tt_cx.jpg" class="img-fluid" v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">
                        <img src="@/assets/gifts/gift_jbl_tt_es.jpg" class="img-fluid" v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                        <img src="@/assets/gifts/gift_jbl_tt_fr.jpg" class="img-fluid" v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                        <img src="@/assets/gifts/gift_jbl_tt_it.jpg" class="img-fluid" v-if="(user.user.language == 'IT' || user.user.language == 'PL')  && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                        <img src="@/assets/gifts/gift_jbl_tt_pt.jpg" class="img-fluid" v-if="user.user.language == 'PT' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                        <img src="@/assets/gifts/gift_jbl_tt_de_1.jpg" class="img-fluid" v-if="user.user.language == 'DE' && user.user.country != 'CH' &&  user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">


                        <div v-if="user.user.language == 'RU' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
                          <p class="mt-0 text-center font-size-18">Ночная крем-маска</p>
                        </div>
                        <div v-if="user.user.language == 'EN' && user.user.country != 'TX' && user.user.country != 'ME' && user.user.is_limited_to_lounge != 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
                          <p class="mt-0 text-center font-size-18">Wrinkle Smoothing Cream</p>
                        </div>
                        <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Essential Energy</p>
                          <p class="mt-0 text-center font-size-18">Moisturizing Gel Cream</p>
                        </div>
                        <div v-if="user.user.language == 'IT' && user.user.country != 'TX' && user.user.is_limited_to_lounge != 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune<br>Eye</p>
                          <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
                        </div>
                        <div v-if="user.user.country == 'BX'">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
                          <p class="mt-0 text-center font-size-18">Uplifting and Firming<br>Day Cream</p>
                        </div>
                        <div v-if="user.user.country == 'ME'">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
                          <p class="mt-0 text-center font-size-18">Defense Refresh Mist</p>
                        </div>
                        <div v-if="user.user.country == 'TX'">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Benefiance</p>
                          <p class="mt-0 text-center font-size-18">Overnight Wrinkle <br> Resisting Cream</p>
                        </div>

                        <div v-if="user.user.country == 'CH' && user.user.is_limited_to_lounge == 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune</p>
                          <p class="mt-0 text-center font-size-18">50ml</p>
                        </div>
                        <div v-if="user.user.language == 'ES' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FSLX</p>
                          <p class="mt-0 text-center font-size-18">Concentrated<br> Balancing Softener</p>
                        </div>
                        <div v-if="user.user.language == 'FR' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Vital Perfection</p>
                          <p class="mt-0 text-center font-size-18">Crème Lift Fermeté<br>Jour et Nuit 50 ml</p>
                        </div>
                        <div v-if="(user.user.language == 'IT' || user.user.language == 'PL') && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">Ultimune <br>Eye</p>
                          <p class="mt-0 text-center font-size-18">Power Infusing Eye<br>Concentrate</p>
                        </div>
                        <div v-if="user.user.language == 'PT' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">White Lucent</p>
                          <p class="mt-0 text-center font-size-18">Brightening Gel Cream</p>
                        </div>
                        <div v-if="user.user.language == 'DE' && user.user.country != 'CH' && user.user.country != 'TX' && user.user.is_limited_to_lounge == 1">
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32">FUTURE SOLUTION LX</p>
                          <p class="mt-0 text-center font-size-12 small" v-html="$t('GIFT_DE_INFO')"></p>
                        </div>
                        <div v-if="user.user.country == 'CX' && user.user.is_limited_to_lounge == 1">

                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'EN'">We will let you know very soon!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'ES'">¡Se lo haremos saber muy pronto!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'FR'">Nous vous le ferons savoir très bientôt !</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PL'">Damy ci znać wkrótce!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'DE'">Das werden Sie hier sehr bald erfahren!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'IT'">Vi faremo sapere molto presto!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'RU'">Мы сообщим вам очень скоро!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'NL'">We laten het u binnenkort weten!</p>
                          <p class="mt-3 mb-0 text-center font-weight-bold font-size-32" v-if="user.user.language == 'PT'">Informá-lo-emos muito em breve!</p>



                        </div>

                      </div>
                    </div>
                    <div class="d-flex justify-content-center align-items-center flex-column" >
                      <div class="btn btn-red text-uppercase mb-4 d-none" v-on:click="openPDFLounge()" v-if="user.user.language == 'IT' && user.user.country == 'IT' && user.user.is_limited_to_lounge == 1" >Regolamento Ministeriale</div>
                      <div class="btn btn-red text-uppercase mb-4" v-on:click="openPDF()" v-if="user.user.language == 'IT' && user.user.country == 'IT' && user.user.is_limited_to_lounge == 0" >Regolamento Ministeriale</div>
                      <div class="btn btn-red text-uppercase" v-on:click="sliderNext()"  v-html="$t('SECTION01_TEXT14')">
                        Great! what else?
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="slide slide-05">
              <div class="slide__inner">

                <h3 class="slide--headline"  v-html="$t('SECTION01_TEXT15')">The City of Tokyo<br>awaits you</h3>

                <div class="row">
                  <div class="col-6 offset-3 col-md-3 offset-md-0 mb-5">
                    <img src="@/assets/global/Miyuki_dori.png" class="img-fluid guide">
                  </div>
                  <div class="col-12 col-md-7 offset-md-1">
                    <p class="slide--text"  v-html="$t('SECTION01_TEXT16')">
                      „If you need any help I you will always find me
                      in the navigation under the icon on the top right.
                    </p>
                    <p class="slide--text"  v-html="$t('SECTION01_TEXT17')">
                      But now let´s discover the districts together“
                    </p>
                    <img src="@/assets/global/world_1_mobile.png" class="img-fluid my-4 d-block d-lg-none">
                    <div class="d-lg-block d-flex align-items-center justify-content-center">
                      <div class="btn btn-red text-uppercase" v-on:click="startWorld()"  v-html="$t('SECTION01_TEXT18')">
                        Yay! Let´s go
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </Slick>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lrsService from "@/services/lrsService";
import Slick from 'vue-slick';
import World from "@/components/WorldOverview";
import jQuery from "jquery";
export default {
  name: "page-010",
  components: {
    Slick,
    World
  },
  props: {
    kapitel: "",
    sliderIndex: 0,
  },
  data: function () {
    return {
      windowWidth: window.innerWidth,
      user: Object,
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        draggable: false,
        accessibility: false,
        infinite: false,
        vertical: false,
        fade: true,
        dots: true,
        swipe: false,
        adaptiveHeight: true
        // Any other options that can be got from plugin documentation
      },
    }
  },
  created() {
              this.$store.watch(
                    (state, getters) => getters.user,
                    (newValue, oldValue) => {
                      let u = this.$store.getters.user;
                      if (typeof u === 'string' || u instanceof String){
                        u = JSON.parse(u)
                      }
                      this.user = u;
                    }
            )
  },
  mounted() {
    let _this = this;
    let u = this.$store.getters.user;
    if (typeof u === 'string' || u instanceof String){
      u = JSON.parse(u)
    }
    this.user = u;
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    openPDFLounge(){
      window.open('/Module/Tokyo/DOUGLAS-TOKYO-TOUR-REGOLAMENTO-MINISTERIALE.pdf', '_blank')
    },
    openPDF(){
      window.open('/Module/Tokyo/REGOLAMENTO_MINIS.pdf', '_blank')
    },
    handleAfterChange(event, slick, currentSlide) {
      this.sliderIndex = currentSlide;
    },
    sliderNext() {
      this.$refs.slick.next();
      let sliderOffset = jQuery('.intro__slider').offset().top;
      jQuery("html, body").animate({ scrollTop: sliderOffset }, 300);
    },
    startWorld() {
      this.$router.push({name: 'pages', params: {kapitel: '00', pageid: "020"}});
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style scoped>

</style>